import { useStytchB2BClient } from '@stytch/react/b2b';
import dayjs from 'dayjs';

import type { OptionType } from '@/api/common';
import { sessionDurationMinutes } from '@/constants';
import { ROUTES } from '@/router';

import { useLogOut } from './useLogOut';

const useSessionExchange = () => {
  const stytch = useStytchB2BClient();
  const { clearCacheOnly } = useLogOut();

  const exchangeSession = async (
    org: OptionType & { instanceId: string },
    {
      rememberLastAccess = true,
      clearCacheAndReload = false,
    }: { rememberLastAccess?: boolean; clearCacheAndReload?: boolean } = {},
  ) => {
    await stytch.session.exchange({
      organization_id: org.id,
      session_duration_minutes: sessionDurationMinutes,
    });

    if (rememberLastAccess) {
      // If the user is switching orgs, we want to remember the last access time to the new org. If
      // this call fails, just log the error and move on.
      try {
        await stytch.self.update({
          untrusted_metadata: {
            lastAccessTime: dayjs().toISOString(),
          },
        });
      } catch (error) {
        console.error(error);
        console.error('Unable to remember this org was most recently used');
      }
    }

    if (clearCacheAndReload) {
      clearCacheOnly();
      // reload the page to clear all state
      window.location.href = ROUTES.appByInstanceId(org.instanceId);
    }
  };

  return { exchangeSession };
};

export default useSessionExchange;
